import { Chip, CircularProgress, Grid, IconButton, Tooltip, Typography, useTheme } from "@material-ui/core"
import ReplayIcon from '@material-ui/icons/Replay'
import React, { Fragment, useState } from 'react'

const Reacreate = ({ handleRecreate }) => {
  const [creating, setCreating] = useState(false)

  const onReacreate = async () => {
    setCreating(true)
    await handleRecreate()
    setCreating(false)
  }

  return (
    <Tooltip
      title={
        <Typography variant="caption">
          Reenviar solicitação de análise para a eagle.
          <br />
          Atenção: Essa ação faz uma nova solicitação à Eagle e substitui o
          resultado da integração atual.
        </Typography>
      }
    >
      <IconButton disabled={creating} onClick={onReacreate}>
        {creating ? <CircularProgress size={12} /> : <ReplayIcon />}
      </IconButton>
    </Tooltip>
  )
}

export const EagleError = ({ status, errorMessage, handleRecreate }) => {
  const theme = useTheme()
  const ChipFather = errorMessage ? Tooltip : Fragment

  return (
    <Grid container alignItems="center">
      <Grid item>
        <ChipFather
          title={
            <Typography variant="caption">
              Mensagem da Eagle: {errorMessage}
            </Typography>
          }
        >
          <Chip
            label={status}
            style={{
              backgroundColor: theme.palette.error.main,
              color: '#fff'
            }}
          />
        </ChipFather>
      </Grid>

      <Grid item>
        <Reacreate handleRecreate={handleRecreate} />
      </Grid>
    </Grid>
  )
}
